import {ReactComponent as Pfeil} from '../../../assets/img/icon/Pfeil.svg';

function ArrowLeft(props) {
    return (
            <Pfeil className={"getStartedArrow left"  + (props.disabled ? " disabled" : "")} onClick={props.onClick} style={props.style}/>
    );

}

export default ArrowLeft;